module.exports = __webpack_public_path__ + "img/hrc-home.a6057b36.webp";